import { i18nFn, MilestonesDTO } from '@springbig/shared';
import { Box, VStack } from 'native-base';
import { CardTitle } from '~/pages/homePage/components/CardTitle';
import CardMilestone from '~/pages/milestone/components/CardMilestone';
import { useHomePageStyles } from '~/shared/styles';
import { CardBottomLink } from '~/pages/homePage/components/CardBottomLink';
import React from 'react';
import { H4 } from '~/shared/Typography';

type MilestonesProps = {
    data: MilestonesDTO;
    t: i18nFn;
};

export const Milestones = ({
    data,
    t,
}: MilestonesProps) => {

    const {
        primary_color,
    } = useHomePageStyles();

    return (
        <VStack space={4}>
            <CardTitle
                title={t('home_page.milestones.title')}
                icon={'faTrophy'}
            />
            <Box>
                <H4 ml={2}>{ t('home_page.milestones.spend_title') }</H4>
                <VStack space={2}>
                    {
                        data &&
                        data.spend_milestones &&
                        data.spend_milestones.milestones.map((milestone, index) =>

                            <Box bg={primary_color} rounded={'2xl'} key={index}>
                                <CardMilestone
                                    currentValue={data.spend_milestones.lifetime_achieved}
                                    milestone={milestone}
                                    t={t}
                                    type={'spend'}
                                />
                            </Box>
                        )}
                </VStack>
            </Box>
            <Box>
                <H4 ml={2}>{ t('home_page.milestones.points_title') }</H4>
                <VStack space={2}>
                    {
                        data &&
                        data.points_milestones &&
                        data.points_milestones.milestones.map((milestone, index) =>

                            <Box bg={primary_color} rounded={'2xl'} key={index}>
                                <CardMilestone
                                    currentValue={data.points_milestones.lifetime_achieved}
                                    milestone={milestone}
                                    t={t}
                                    type={'spend'}
                                />
                            </Box>
                        )}
                </VStack>
            </Box>
            <CardBottomLink t={t} text={'home_page.view_more'} link={'milestones'} />
        </VStack>
    );
};
